import constant from "@/utils/constant";
import { PAGES_PATH, PAGES_NAME } from "@/utils/route";

/*=========================================================================================
  File Name: navMenuItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Structure:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group

==========================================================================================*/

export default () => [
	{
		url: PAGES_PATH.PAGE_CBS_POST_PATH,
		name: "Post",
		slug: "post",
		icon: "nucleo nucleo-billboard-2",
		i18n: "PostsManagement",
		iconPack: "nucleo",
		featherIcon: false
	},
	{
		url: PAGES_PATH.PAGE_CBS_ALARM_PATH,
		name: "Alarm",
		slug: "alarm",
		icon: "nucleo nucleo-megaphone-2",
		i18n: "AlarmsList",
		iconPack: "nucleo",
		featherIcon: false
	},
	{
		name: "Todo List",
		icon: "nucleo nucleo-archive-paper-2",
		i18n: "TodoList",
		iconPack: "nucleo",
		featherIcon: false,
		permissionKeys: [constant.PERMISSION.TODOLIST.CAN_VIEW],
		submenu: [
			{
				url: PAGES_PATH.PAGE_CBS_TODO_PATH,
				name: PAGES_NAME.PAGE_CBS_TODO_NAME,
				slug: "todo-list",
				i18n: "All",
				query: { page: 1 }
			},
			{
				url: PAGES_PATH.PAGE_CBS_MY_TODO_PATH,
				name: PAGES_NAME.PAGE_CBS_MY_TODO_NAME,
				slug: "my-todo-list",
				i18n: "MyTodoList",
				query: { page: 1 }
			}
		]
	},
	{
		name: "Request",
		slug: "request",
		icon: "nucleo nucleo-file-paragraph",
		i18n: "Request",
		iconPack: "nucleo",
		featherIcon: false,
		permissionKeys: [constant.PERMISSION.REQUEST.CAN_VIEW],
		submenu: [
			{
				url: PAGES_PATH.PAGE_CBS_REQUEST_PATH,
				name: PAGES_NAME.PAGE_CBS_REQUEST_NAME,
				slug: "request-list",
				i18n: "All",
				query: { page: 1 }
			},
			{
				url: PAGES_PATH.PAGE_CBS_REQUESTS_CREATED_BY_ME_PATH,
				name: PAGES_NAME.PAGE_CBS_REQUESTS_CREATED_BY_ME_NAME,
				slug: "my-created-requests",
				i18n: "MyCreatedRequests",
				query: { page: 1 }
			},
			// {
			// 	url: PAGES_PATH.PAGE_CBS_REQUESTS_RELATING_TO_ME_PATH,
			// 	name: PAGES_NAME.PAGE_CBS_REQUESTS_RELATING_TO_ME_NAME,
			// 	slug: "my-relating-requests",
			// 	i18n: "MyRelatingRequests",
			// 	query: { page: 1 }
			// },
			{
				url: PAGES_PATH.PAGE_CBS_REQUESTS_APPROVE_BY_ME_PATH,
				name: PAGES_NAME.PAGE_CBS_REQUESTS_APPROVE_BY_ME_NAME,
				slug: "approve-by-me-requests",
				i18n: "ApproveByMeRequests",
				query: { page: 1 }
			}
		]
	},
	{
		url: PAGES_PATH.PAGE_CBS_DEVICE_PATH,
		name: "Device",
		slug: "Device",
		icon: "nucleo nucleo-server-2",
		i18n: "Device",
		iconPack: "nucleo",
		featherIcon: false
	},
	{
		name: "Employee",
		slug: "employee",
		icon: "nucleo nucleo-users-mm-2",
		i18n: "Employee",
		iconPack: "nucleo",
		featherIcon: false,
		permissionKeys: [constant.PERMISSION.EMPLOYEE.CAN_VIEW],
		url: PAGES_PATH.PAGE_CBS_EMPLOYEE_PATH

		// submenu: [
		// 	{
		// 		url: PAGES_PATH.PAGE_CBS_EMPLOYEE_PATH,
		// 		name: PAGES_NAME.PAGE_CBS_EMPLOYEE_NAME,
		// 		slug: "employee-list",
		// 		i18n: "All",
		// 		query: { page: 1 }
		// 	},
		// 	...generateDynamicSubMenu("employees", departments)
		// ]
	},
	{
		name: "EconomicContract",
		slug: "economicContract",
		icon: "nucleo nucleo-document-2",
		i18n: "EconomicContractsList",
		iconPack: "nucleo",
		featherIcon: false,
		permissionKeys: [constant.PERMISSION.ECONOMIC_CONTRACT.CAN_VIEW],
		url: PAGES_PATH.PAGE_CBS_ECONOMIC_CONTRACT_PATH
	},
	{
		name: "Customer",
		slug: "post",
		icon: "nucleo nucleo-cmcustomer-glyph",
		i18n: "CustomersManagement",
		iconPack: "nucleo",
		featherIcon: false,
		permissionKeys: [constant.PERMISSION.CUSTOMER.CAN_VIEW],
		submenu: [
			{
				url: PAGES_PATH.PAGE_CBS_CUSTOMER_PATH,
				name: PAGES_NAME.PAGE_CBS_CUSTOMER_NAME,
				slug: "customers-management",
				i18n: "List",
				query: { page: 1 }
			},
			// {
			// 	url: PAGES_PATH.PAGE_CBS_CUSTOMER_LIST_PRODUCTS_PATH,
			// 	name: PAGES_NAME.PAGE_CBS_CUSTOMER_LIST_PRODUCTS_NAME,
			// 	slug: "customers-products",
			// 	i18n: "Products",
			// 	query: { page: 1 }
			// },
			{
				url: PAGES_PATH.PAGE_CBS_CUSTOMER_QUOTE_PATH,
				name: PAGES_NAME.PAGE_CBS_CUSTOMER_QUOTE_NAME,
				slug: "customers-quote",
				i18n: "Quote",
				query: { page: 1 }
			}
		]
	},
	{
		name: "Inventory",
		slug: "post",
		icon: "nucleo nucleo-storage-unit",
		i18n: "InventoriesManagement",
		iconPack: "nucleo",
		featherIcon: false,
		permissionKeys: [constant.PERMISSION.INVENTORY.CAN_VIEW, constant.PERMISSION.PRODUCT.VIEW],
		submenu: [
			{
				url: PAGES_PATH.PAGE_CBS_INVENTORY_PATH,
				name: PAGES_NAME.PAGE_CBS_INVENTORY_NAME,
				slug: "inventories-management",
				i18n: "List",
				query: { page: 1 }
			},
			{
				url: PAGES_PATH.PAGE_CBS_CUSTOMER_LIST_PRODUCTS_PATH,
				name: PAGES_NAME.PAGE_CBS_CUSTOMER_LIST_PRODUCTS_NAME,
				slug: "customers-products",
				i18n: "Products",
				query: { page: 1 }
			}
		]
	},
	{
		name: "Note",
		slug: "note",
		icon: "nucleo nucleo-single-content-03-2",
		i18n: "Note",
		iconPack: "nucleo",
		featherIcon: false,
		url: PAGES_PATH.PAGE_CBS_NOTE_PATH

		// submenu: [
		// 	{
		// 		url: PAGES_PATH.PAGE_CBS_NOTE_PATH,
		// 		name: PAGES_NAME.PAGE_CBS_NOTE_NAME,
		// 		slug: "my-notes-list",
		// 		i18n: "MyNotes",
		// 		query: { page: 1 }
		// 	}
		// ]
	},
	{
		name: "General Settings",
		slug: "general-settings",
		icon: "nucleo nucleo-settings-gear-2",
		i18n: "GeneralSettings",
		iconPack: "nucleo",
		featherIcon: false,
		permissionKeys: [
			constant.PERMISSION.REQUEST_TYPE.CAN_VIEW,
			constant.PERMISSION.REPORT_FORM.CAN_VIEW,
			constant.PERMISSION.TODOLIST.CAN_VIEW,
			constant.PERMISSION.TAG.VIEW,
			constant.PERMISSION.PIPELINE.VIEW,
			constant.PERMISSION.ALARM.VIEW
		],
		submenu: [
			{
				url: PAGES_PATH.PAGE_CBS_ALARM_SETTING_PATH,
				name: PAGES_NAME.PAGE_CBS_ALARM_SETTING_NAME,
				slug: PAGES_NAME.PAGE_CBS_ALARM_SETTING_NAME,
				i18n: "AlarmsList",
				query: { page: 1 },
				permissionKeys: [constant.PERMISSION.ALARM.VIEW]
			},
			{
				url: PAGES_PATH.PAGE_CBS_REQUEST_TYPES_PATH,
				name: PAGES_NAME.PAGE_CBS_REQUEST_TYPES_NAME,
				slug: PAGES_NAME.PAGE_CBS_REQUEST_TYPES_NAME,
				i18n: "ConfigRequestType",
				query: { page: 1 }
			},
			{
				url: PAGES_PATH.PAGE_CBS_REPORT_FORM_PATH,
				name: PAGES_NAME.PAGE_CBS_REPORT_FORM_NAME,
				slug: PAGES_NAME.PAGE_CBS_REPORT_FORM_NAME,
				i18n: "ReportForm",
				query: { page: 1 }
			},
			{
				url: PAGES_PATH.PAGE_CBS_CUSTOMER_CLASSIFICATION_PATH,
				name: PAGES_NAME.PAGE_CBS_CUSTOMER_CLASSIFICATION_NAME,
				slug: PAGES_NAME.PAGE_CBS_CUSTOMER_CLASSIFICATION_NAME,
				i18n: "ManageCustomerClassification",
				query: { page: 1 },
				permissionKeys: [constant.PERMISSION.PIPELINE.VIEW]
			},
			{
				url: PAGES_PATH.PAGE_CBS_TAG_LIST_PATH,
				name: PAGES_NAME.PAGE_CBS_TAG_LIST_NAME,
				slug: PAGES_NAME.PAGE_CBS_TAG_LIST_NAME,
				i18n: "TagList",
				query: { page: 1 },
				permissionKeys: [constant.PERMISSION.TAG.VIEW]
			}
		]
	},
	{
		url: PAGES_PATH.PAGE_CBS_USER_GUIDE,
		name: "User Guide",
		slug: "user-guide",
		icon: "nucleo nucleo-contacts-2",
		i18n: "UserGuide",
		iconPack: "nucleo",
		featherIcon: false
	}
];
